export default __webpack_public_path__ + "images/lightbulb-outline-white.38d76e4ad1ded2a372dbefe5f96ed982.png";